import { AppModal } from '@/components/AppModal'

const CONTACT_FORM_URL = 'https://irogami-taiken.com/#section-694'

interface ForgotEmailModalProps {
  show: boolean
  onClose: () => void
}

function ForgotEmailModal({ show, onClose }: ForgotEmailModalProps) {
  if (!show) return null

  return (
    <AppModal isOpen={show} onClose={onClose} title="メールアドレスを忘れた場合" maxWidth={440}>
      <p className="forgot-password-modal__description">
        メールアドレスの確認・変更をご希望の際は、
        <a
          href={CONTACT_FORM_URL}
          className="link-text forgot-email-modal__contact-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          お問い合わせフォーム
        </a>
        よりご連絡ください。
        <br />
        変更をご希望の場合は、新しいメールアドレスをご入力ください。
        <br />
        <br />
        ※学校代表メールアドレスでの登録を推奨しています。
      </p>
      <div className="app-modal__actions">
        <button type="button" onClick={onClose} className="editable-field-button">
          閉じる
        </button>
      </div>
    </AppModal>
  )
}

export default ForgotEmailModal
